module.exports = __webpack_public_path__ + "static/media/Page01.1d20175d.png";